import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { ConnectorListParams, ConnectorListResponse } from '@/entities/connector/types';

export const getConnectorsApi = async (params?: ConnectorListParams): Promise<ConnectorListResponse> => {
  const { data } = await connectorApiClient.get<ConnectorListResponse>('/connectors', {
    params,
    paramsSerializer: {
      serialize: (nextParams = {}) => {
        const searchParams = new URLSearchParams();

        const appendParamValue = (key: string, value: unknown) => {
          searchParams.append(key, String(value));
        };

        Object.entries(nextParams).forEach(([key, value]) => {
          if (value === undefined || value === null) {
            return;
          }

          if (Array.isArray(value)) {
            value.forEach((item) => {
              if (item === undefined || item === null) {
                return;
              }

              appendParamValue(key, item);
            });
            return;
          }

          appendParamValue(key, value);
        });

        return searchParams.toString();
      },
    },
  });
  return data;
};
